export default __webpack_public_path__ + "static/image-6-c8b1bdadf9ac4451c2210b9ea2c520b8.jpg";